import React from 'react';
import { ASSISTED_TRANSFER, QUEUE_COUNT, ALERTS_SHOWED_CODE, USER_STATE, STATE_TO_PLAY_END_AUDIO, BLIND_TRANSFER } from '../../constants.js';
import { messageKeepAlive } from '../../js/helpers/helperMessages';
import { STRATEGIES_API_RESPONSE } from '../../js/Strategies/Strategies_Api_Response';
import { STRATEGIES_ALERTS } from '../../js/Strategies/Strategies_Alerts_And_Errors';
import SingletonWebSocket from '../Singletons/SingletonWebSocket';
import { SM_QUEUE_SERVER } from '../../constants';
import { STRATEGIES_EXTERNAL_MESSAGING } from '../../js/Strategies/Strategies_External_Messaging';
import { Logger } from '../helpers/Logger.js'
import { STRATEGIES_PREVIEW_TRANSFER } from '../../js/Strategies/Strategies_Preview_Transfer';
import { AgentButton } from 'global-components-library';
import { SingletonSharedData } from '../singletonSharedData.js';
import { STRATEGIES_AGENT_PERMISSIONS } from './Strategies_Agent_Permissions.js';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js'
import { getCurrentTimeInSec } from '../helpers/Utils/formats.js';
import { STRATEGIES_CONNECT_CALL } from './Strategies_Preview_ConnectCall.js';
import { Strategies_Preview_RecState } from './Strategies_Preview_RecState.js';
const sharedData = new SingletonSharedData();
export const STRATEGIES_ACTIONS = {
  "RingingListening": (message, that) => {
    STRATEGIES_ACTIONS["dataCall"](message, that); 
    STRATEGIES_CONNECT_CALL["RingingListening"](message,that);
  },
  "CallTypeRecive": (message, that) => { that.setState({ callType: message.callType }); },
  "chatAdmin": function (message, that) {
    that.props.messageFromSupervisor(message.Message, message.From);

  },
  "dataCall": function (message, that) {
    let APIFact = new APIFactory();
    let apiCont = APIFact.buildClient();
    if (message.CallId) {
      that.callId = message.CallId;
    }
    if (message.CallOutId!=that.callOutId) {
      message.CallOutId=that.callOutId;
    }
    let speaker = that.sharedData.getVolumeSpeaker();
    let microphone = that.sharedData.getVolumeMic();
    if (speaker === 0) {
      speaker = 70;
      that.sharedData.setVolumeSpeaker(speaker);
    }
    if (microphone === 0) {
      microphone = 70;
      that.sharedData.setVolumeMic(microphone);
    }
    if (message.CallType === 1) {
      let objectResponseRecordCall = apiCont.getObjectResponse();
			Logger.Trace('apiCont.RecordCall request');
      let objectDataRecord = {
        campId: message.Id,
        option: message.CallType,
      };
			apiCont.GetRecordCallPermission(objectDataRecord, objectResponseRecordCall);
			objectResponseRecordCall.onError = err => {
				Logger.Warn('apiCont.RecordCall objectData:', objectDataRecord, 'error:', err);
			};
			objectResponseRecordCall.onSuccess = function (objResponse) {
				Logger.Trace('apiCont.RecordCall onSucces:', objResponse);
				sharedData.setAllowMarksPermission(objResponse !== 3 );
			};
		}
    let objectData = {
      UserId: that.sharedData.getParameters().UserID,
      Id: message.Id,
      CallType: message.CallType,
      CallOutId: message.CallOutId,
      Phone: message.Phone
    };
    let objectResponseCallIcon = apiCont.getObjectResponse();
    Logger.Trace("apiCont.callIcon request");
    apiCont.callIcon(objectData, objectResponseCallIcon);
    objectResponseCallIcon.onError = (err) => {
      Logger.Warn("apiCont.callIcon objectData:", objectData, "error:", err);
      message.Description="";
      that.sharedData.setCallIcon(null);
      if (message.action!="RingingListening") {
        const integrationMessage = { client: "galatea", data: message, action: "CallFlow", subaction: "onCallRecieved" };
        SingletonWebSocket.send(integrationMessage);
      }
    };
    objectResponseCallIcon.onSuccess = function (objResponse) {
      Logger.Trace("apiCont.callIcon onSucces:", objResponse);
      message.Description=objResponse.Description;
      that.sharedData.setCallIcon(objResponse);
      if (message.action!="RingingListening") {
        const integrationMessage = { client: "galatea", data: message, action: "CallFlow", subaction: "onCallRecieved" };
        SingletonWebSocket.send(integrationMessage);
      }
    }
    Logger.Info("[StrategiesAction][DataCall] get volume speaker:" + speaker + " microphone:" + microphone + "");
    that.agentController.volumeSpeaker(speaker);
    that.agentController.volumeMicrophone(microphone);
    Logger.Info("[StrategiesAction][DataCall] get volume controller speaker:" + that.agentController.volumeSpeakerGet() + " microphone:" + that.agentController.volumeMicrophoneGet() + "");
    that.setState({ dataCall: message });
    that.connectCall(message, that.sharedData.getParameters().UserID);
  },
  "extraDataCall": function (message, that) {
    if (message.CallId) {
      that.callId = message.CallId;
    }
    that.setState({ extraDataCall: message });

    if(that.sharedData.getDataPreviewPro().dialingMode == 1 && message.Type == "ON_DATA"){
      that.props.saveDataFromTransfer(message);
      that.setState({ dataCall: message });
    }

    if (message.SrcUserId) {
      that.connectCall(message, message.SrcUserId);
      const integrationMessage = { client: "galatea", data: message, action: "CallFlow", subaction: "onCallRecieved" };
      SingletonWebSocket.send(integrationMessage);
    }
    else {
      switch (message.Type) {
        case ASSISTED_TRANSFER.SECOND_CALL_CONNECTED:
          that.props.newAssistedTransferState(ASSISTED_TRANSFER.SECOND_CALL_CONNECTED);
          let integrationMessage = { client: "galatea", action: "AssistedTransfer", subaction: "onSecondCallConected" };
          SingletonWebSocket.send(integrationMessage);
          break;
        case ASSISTED_TRANSFER.ON_STATUS:
          that.props.newAssistedTransferState(ASSISTED_TRANSFER.ON_STATUS);
          break;
        case ASSISTED_TRANSFER.SECOND_CALL_HANG_UP:
          (!that.sharedData.getextraCallsConference() && that.props.newAssistedTransferState(ASSISTED_TRANSFER.SECOND_CALL_HANG_UP));
          let error = null;
          if (message.AlertCode !== "0") {
            if(message.AlertCode === "1517"){
              that.props.showAlert();
              let msg = that.language.getText("GUIAlertTransferswitchedError");
              let titleAlert = that.language.getText("GUIAlertTransfertransferError");
              that.props.addToast(msg, {
                group: 'icon',
                position: 'topRight',
                title: titleAlert,
                color: 'red',
                btnComponent: <AgentButton type='tertiary'>{that.language.getText("GUIAlertTransferadmit")}</AgentButton>,
                timeout: 5000,
                onDismiss: that.props.showAlert()
              });
            }
            else{
              const _that = that;
              error = STRATEGIES_ALERTS["TRANSFER_CALL"](message, that);
              that.setState({ alert: error });
            }
          }
          error = error ? error.error : "";
          integrationMessage = { client: "galatea", action: "AssistedTransfer", subaction: "onSecondCallHangUp", data: error };
          SingletonWebSocket.send(integrationMessage);
          break;
        case ASSISTED_TRANSFER.CONFERENCE_CALL_CONNECTED:
          that.setState({ isInConference: true });
          that.sharedData.setConferenceCallID(message.CallId);
          that.props.newAssistedTransferState(ASSISTED_TRANSFER.CONFERENCE_CALL_CONNECTED);
          break;
        case ASSISTED_TRANSFER.CONFERENCE_CALL_HANG_UP:
          that.sharedData.setConferenceHangUpOther(message.CallId);
          that.props.newAssistedTransferState(ASSISTED_TRANSFER.CONFERENCE_CALL_HANG_UP);
          break;
        case ASSISTED_TRANSFER.NEW_SECOND_CALL_SET:
          that.props.newAssistedTransferState(ASSISTED_TRANSFER.NEW_SECOND_CALL_SET);
          break;
        case ASSISTED_TRANSFER.IDDLE_END:
          that.props.newAssistedTransferState(ASSISTED_TRANSFER.IDDLE_END);
          break;
        case BLIND_TRANSFER.BLIND_TRANSFER_HANG_UP:
          let msg;
          let titleAlert = that.language.getText('GUIAlertTransfertransferError');
          if(message.AlertCode === "1501")
            msg = that.language.getText('CallControlGUICallTransferno-answer-error');
          else msg = that.language.getText('alert-' + message.AlertCode);

          if(msg === "" || msg === undefined){
            titleAlert = "";
            msg = that.language.getText("CallControlGUICallTransferBlindXferError");
          }
          that.props.showAlert();
          that.props.addToast(msg, {
            group: 'icon',
            position: 'topRight',
            title: titleAlert,
            color: 'red',
            btnComponent: <AgentButton type='tertiary'>{that.language.getText("GUIAlertTransferadmit")}</AgentButton>,
            timeout: 5000,
            onDismiss: that.props.showAlert()
          });
          that.props.resetTransfer();
        default:
          break;
      }

    }
  },
  "dialogTime": (message,that) => {
    if(that.sharedData.getDataPreviewPro().dialingMode === 1 )
    {
      that.props.setDialogTime(Math.round(message.dialogTime));
      Strategies_Preview_RecState[message.action](message, that)
    } 
    const integrationMessage = { client: "galatea", data: message, action: "onCallEnds" };
    SingletonWebSocket.send(integrationMessage);
    const _that = that;
    const isHangedUpByAgent =  sharedData.getIsHangedUpByAgent();
    if(isHangedUpByAgent === STATE_TO_PLAY_END_AUDIO.HANG_UP_CLIENT){
      const audioToPlay = sharedData.getAudioNotificationCallEnd();
        if(audioToPlay){
            const audio = new Audio(audioToPlay);
            audio.play();
        }
    }
  },
  "StartKeepAlive": function (message, that) {
    if (!that.timerKeepAlive) {
      that.timerKeepAlive = setInterval(keepAlive, 10000);
      const _that = that;
      function keepAlive() {
        let userName = _that.sharedData.getUserData().Login;
        let timeStamp = _that.agentController.getTimeStamp();
        let msgKeepAlive = messageKeepAlive(userName, timeStamp);
        // Logger.Trace("KeepAlive", msgKeepAlive);
        _that.sendToRabbit(SM_QUEUE_SERVER, msgKeepAlive);
      }
    }
  },
  "queueCall": function (message, that) {
    let CallOnQueue = { acdID: message.IdACDReceived, nQueue: message.CountACDReceived, secondsOnQueue: message.SecondsACDReceived };
    const integrationMessage = { client: "galatea", data: CallOnQueue, action: "onCallsOnQueue" };
    SingletonWebSocket.send(integrationMessage);
    that.props.updateCount(QUEUE_COUNT.CALLS, message.Count, message.Seconds);
    //that.setState({ idChangeCount: QUEUE_COUNT.CALLS, queueCount: message.Count, timeInQueue: message.Seconds });
  },
  "ApiResponse": function (message, that) {
    STRATEGIES_API_RESPONSE[message.Subaction](message, that);
  },
  "notReadyScheduled": (message, that) => {
    that.setState({ newAlertCode: ALERTS_SHOWED_CODE.REPROGRAM_NA_STATE, newAlertMessage: message });
    if(that.sharedData.getDataPreviewPro().dialingMode === 1 )
    {
      Strategies_Preview_RecState[message.action](message, that)
    } 
  },
  "EXTERNAL_MESSAGING": (message, that) => {
    STRATEGIES_EXTERNAL_MESSAGING[message.subAction](message, that);
  },
  "ERROR_MMC": (message, that) => {
    STRATEGIES_EXTERNAL_MESSAGING[message.subAction](message, that);
  },
  "NewPreviewCall": (message, that) => {
    let data = {
      CamId: message.CamId,
      Id: message.CamId,
      CallKey: message.CallKey,
      CalKey: message.CallKey,
      Phone: message.PhoneNumber,
      Data: "",
      ExistsCallout: 0,
      CallMode: 2,
      integration: false,
      campaignName: message.CampaignName,
      CallId: message.CallOutId,
    }
    that.setState({ dataCall: data });
    that.props.manualCall(data);
    const integrationData = {
      action:message.action,
      CalKey:message.CallKey,
      CallId:that.callId,
      CallOutId:message.CallOutId,
      CallType:2,
      DataContact:message.Data,
      Description:message.CampaignName,
      Id:message.CamId,
      Phone:message.PhoneNumber,
      Port:message.Port,
      WrapUpTime:message.WrapUpTime,
    }
    that.sharedData.setIntegrationCallData(integrationData);
  },
  "PREVIEWPRO": (message, that) => {
    if(message.DialingMode === 500){
      that.props.showAlert();
      let msg = that.language.getText("GUIAlertTransferunexpectedError")//"Ocurrió un problema inesperado";
      let titleAlert = that.language.getText("GUIAlertTransfertransferError")//"Error al realizar transferencia";
      that.props.addToast(msg, {
        title: titleAlert,
        group: 'icon',
        position: 'topRight',
        color: 'red',
        btnComponent: <AgentButton type='tertiary'>{that.language.getText("GUIAlertTransferclose")}</AgentButton>,
        timeout: 5000,
        onDismiss: that.props.showAlert()
    });
    
    }else{
      if([100,101,200,201].includes(message.DialingMode)){ 
        const isEnabled = message.DialingMode === 201 ||  message.DialingMode === 101
        that.props.setAllowChangeDialingMode(isEnabled);
        if(that.sharedData.getDataPreviewPro().dialingMode === 1){
          let msg = isEnabled ? that.language.getText("GUIAlertMessagecamEnable") : that.language.getText("GUIAlertMessagecamDisabled");
          that.props.addToast(msg, {
            group: 'icon',
            position: 'topRight',
            icon: 'camps',
            btnComponent: <AgentButton type='tertiary'>{that.language.getText("GUIAlertMessageclose")}</AgentButton>,
            timeout: 5000,
          });
        }
        return;
      }
      that.sharedData.setDataPreviewPro(message.DialingMode, that.sharedData.getDataPreviewPro().allowChangeDialMode);
      let msg = message.DialingMode === 1 ? that.language.getText("GUIAlertMessagepreviewMode") : that.language.getText("GUIAlertMessagedefaultMode");
      that.props.addToast(msg, {
        group: 'icon',
        position: 'topRight',
        icon: 'camps',
        btnComponent: <AgentButton type='tertiary'>{that.language.getText("GUIAlertMessageok")}</AgentButton>,
        timeout: 5000,
      });
    }
  },
  "previewData": (message, that) => {
    that.sharedData.setDataCallPreview(message);
    let msg = that.language.getText("GUIAlertMessagemsgAssignAgain");
    message.IsReassigned && that.props.addToast(msg, {
      group:'snackbar',
			btnComponent: <AgentButton type='tertiary'>{that.language.getText("GUIAlertMessageclose")}</AgentButton>,
			position: 'topRight',
			type: 'light',
			timeout: 5000
    });
  },
  "previewScheduled": (message, that) => {
    let msg = message.DialingMode === 1 ? that.language.getText("GUIAlertMessagepreviewMode") : that.language.getText("GUIAlertMessagedefaultMode");
    let closeButton = <AgentButton type='tertiary'>{that.language.getText("GUIAlertMessageok")}</AgentButton>
    if([100,101,200,201].includes(message.DialingMode) && that.sharedData.getDataPreviewPro().dialingMode === 1){ 
      const isEnabled = message.DialingMode === 201 ||  message.DialingMode === 101
      msg = isEnabled ? that.language.getText("GUIAlertMessagecamEnable") : that.language.getText("GUIAlertMessagecamDisabled");
      closeButton =  <AgentButton type='tertiary'>{that.language.getText("GUIAlertMessageclose")}</AgentButton>
      that.props.setAllowChangeDialingMode(isEnabled);
    }
    that.props.addToast(msg, {
      group: 'icon',
      position: 'topRight',
      icon: 'camps',
      btnComponent: closeButton ,
      timeout: 5000,
    });
  },
  "previewChangeCampaign":(message, that) =>{
    if(message.DialingMode===3){
      that.sharedData.setDataPreviewPro(that.sharedData.getDataPreviewPro().dialingMode,true);
    }else{
      that.sharedData.setDataPreviewPro(that.sharedData.getDataPreviewPro().dialingMode, false);
    }
    let msg = message.DialingMode === 3 ? that.language.getText("GUIAlertMessageenableChangeCampaignType") : that.language.getText("GUIAlertMessagedisableChangeCampaignType");
    that.props.addToast(msg, {
      group: 'icon',
      position: 'topRight',
      icon: 'camps',
      btnComponent: <AgentButton type='tertiary'>{that.language.getText("GUIAlertMessageok")}</AgentButton>,
      timeout: 5000,
    });
  },
  "dataCallPreview": (message, that) => {
    that.setState({ dataCall: message });
    that.connectCall(message, that.sharedData.getParameters().UserID);
    const integrationMessage = { client: "galatea", data: message, action: "CallFlow", subaction: "onCallRecieved" };
    SingletonWebSocket.send(integrationMessage);
  },
  "AGENT_BUSY": function (message, that) {
    that.props.showAlert();
    let msg = that.language.getText("GUIAlertTransferswitchedError");
    let titleAlert = that.language.getText("GUIAlertTransfertransferError");
        
    that.props.addToast(msg, {
      group: 'icon',
      position: 'topRight',
      title: titleAlert,
      color: 'red',
      btnComponent: <AgentButton type='tertiary'>{that.language.getText("GUIAlertTransferadmit")}</AgentButton>,
      timeout: 5000,
      onDismiss: that.props.showAlert()
      });
    that.props.resetTransfer();
    let data ={ agent:that.sharedData.getConferenceNewNumber(), error:message.Module}
    let integrationMessage = { client: "galatea", action: "TransferOption", subaction: "onUnavailableAgent", data: data };
    SingletonWebSocket.send(integrationMessage);
  },
  "TransferPreviewCall": function(message,that){
    STRATEGIES_PREVIEW_TRANSFER[message.subAction](message, that);
  },
  "showPreviewDataTransfer": (message,that) =>{
    that.props.showPreviewData(message.showPreview);
  },
  "UPDATE_DATA_CALL": (message,that) =>{
    that.sharedData.getDataPreviewPro().dialingMode === 1 && that.props.updatePreviewRecord(message);
    let msg = (message.IsSave )? that.language.getText("GUIAlertMessagesuccesUpdate") : that.language.getText("GUIAlertMessageunsuccesUpdate");
    that.sharedData.getDataPreviewPro().dialingMode === 1 && that.props.addToast(msg, { 
				group: 'icon',
				position: 'topRight', 
        color: message.IsSave ? 'green' : 'red', 
				btnComponent: <AgentButton color='tertiary'>{that.language.getText("GUIAlertMessageClose")}</AgentButton>,
				timeout: 5000,
			});
    that.sharedData.getDataPreviewPro().dialingMode !== 1 && that.props.addToast(msg, { 
				group: 'icon',
				position: 'topRight', 
        color: message.IsSave ? 'green' : 'red', 
				btnComponent: <AgentButton color='tertiary'>{that.language.getText("GUIAlertMessageclose")}</AgentButton>,
				timeout: 5000,
			});
    let newData={
      CalKey:that.state.dataCall.CalKey,
      IsSave:message.IsSave,
      DataContact:message.DataContact
    }
    const integrationMessage = { client: "galatea", data: newData, action: "updatedCallData" };
    SingletonWebSocket.send(integrationMessage);
  },
  "ChangeDialingModeScheduled":(message,that) => {
    let preCampType = that.sharedData.getDataPreviewPro().dialingMode;
    if((preCampType === 1 && message.nextStatus === 3) || (preCampType === 0 && message.nextStatus === 31))
    {
      that.props.isSuccessfullChangeCamp({flag:true, nextCampType:message.nextStatus});
    } else{
      that.props.isSuccessfullChangeCamp(false);
    }
  },
  "AGENT_PERMISSIONS": (message, that) => {
    STRATEGIES_AGENT_PERMISSIONS[message.subAction](message, that);
  },
  "Preview": (message, that) => {
    if(message.Process === 0){
      if(that.sharedData.getAgentList().length > 0){
      that.props.addToast(
          that.language.getText('GUIPreviewunassignSuccess'), { 
          group: 'icon',
          position: 'topRight', 
          color: 'green' , 
          btnComponent: <AgentButton color='tertiary'>{that.language.getText("GUIAlertMessageok")}</AgentButton>,
          timeout: 5000,
      })
      }else{
          that.props.addToast(
            that.language.getText('GUIPreviewunassignWarning'), { 
            group: 'icon',
            position: 'topRight', 
            icon: 'warning', 
            color:'yellow',
            btnComponent: <AgentButton color='tertiary'>{that.language.getText("GUIAlertMessageok")}</AgentButton>,
            timeout: 5000,
          })
      }
    }
    if(message.Process === 1){
      that.props.addToast(
        that.language.getText('GUIAlertMessagedeleteSuccess'), { 
          group: 'icon',
          position: 'topRight', 
          color: 'green' , 
          btnComponent: <AgentButton color='tertiary'>{that.language.getText("GUIAlertMessageok")}</AgentButton>,
          timeout: 5000,
      })
    }
  },
  "NotifyCleanDisplay": (message, that) => {
    if(that.sharedData.getDataPreviewPro().dialingMode === 0 )
    {
      that.props.showDataTransferBySetting(true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/Strategies/StrategiesActions.js